import React from "react";
import { Plant } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const NewMonthDialog = ({ open, monthLabel, firstDayLabel, dropped, onUpdate, onSkip }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onSkip()}>
    <DialogContent className="max-w-lg bg-white border-[1.5px] border-black rounded-2xl" data-testid="new-month-dialog">
      <DialogHeader>
        <DialogTitle className="font-heading uppercase text-2xl flex items-center gap-2">
          <Plant size={26} weight="duotone" /> Welcome back! It's a new month
        </DialogTitle>
        <DialogDescription className="text-black/80 text-base leading-relaxed pt-2">
          Your forecast now starts in <strong>{monthLabel}</strong>, so your opening balance needs to be
          what was in your accounts on <strong>{firstDayLabel}</strong>. Everything else you've entered is safe.
        </DialogDescription>
      </DialogHeader>
      {dropped.length > 0 && (
        <div className="bg-[#FFF7E5] border-l-4 border-[#FFBD4A] p-4 rounded-r-lg text-sm" data-testid="new-month-dropped">
          <p className="font-semibold mb-2">
            These were planned for before your forecast now starts, so they're no longer included:
          </p>
          <ul className="list-disc pl-5 space-y-1">
            {dropped.map((d) => (
              <li key={d}>{d}</li>
            ))}
          </ul>
          <p className="mt-2">If any of these haven't happened yet, just add or update them in the right step.</p>
        </div>
      )}
      <div className="flex flex-col sm:flex-row sm:items-center gap-3 pt-2">
        <button type="button" className="btn-primary" onClick={onUpdate} data-testid="new-month-update-btn">
          Update my opening balance
        </button>
        <button type="button" className="text-sm underline font-semibold" onClick={onSkip} data-testid="new-month-skip-btn">
          It hasn't changed, carry on
        </button>
      </div>
    </DialogContent>
  </Dialog>
);

export default NewMonthDialog;
